import { useEffect, useState } from 'react';
import { InputNumber } from 'primereact/inputnumber';
import { InputText } from 'primereact/inputtext';
import { classNames } from 'primereact/utils';

const InputRut = ({ value, onChange, className, disabled }) => {
    const parts = value.split('-');
    const [numericRut, setNumericRut] = useState(parts[0] || undefined);
    const [dvRut, setDvRut] = useState(parts[1] || '');

    const onNumericRutChange = (e) => {
        setNumericRut(e.value);

        if (onChange) {
            const val = (e.value || '') + '-' + dvRut;
            onChange(val === '-' ? '' : val);
        }
    };

    const onDvRutChange = (e) => {
        setDvRut(e.target.value.toUpperCase());

        if (onChange) {
            const val = (numericRut || '') + '-' + e.target.value.toUpperCase();
            onChange(val === '-' ? '' : val);
        }
    };

    useEffect(() => {
        const parts = value.split('-');

        if (parts.length > 0) {
            setNumericRut(parts[0]);
            if (parts.length > 1) {
                setDvRut(parts[1]);
            } else {
                setDvRut('');
            }
        } else {
            setNumericRut(undefined);
            setDvRut('');
        }
    }, [value]);

    return (
        <div className={classNames('p-inputgroup', 'p-inputrut', className)}>
            <InputNumber
                className="p-inputrut-numeric"
                value={numericRut}
                maxLength={10}
                locale="es-CL"
                onValueChange={onNumericRutChange}
                disabled={disabled}
            />
            <span className="p-inputgroup-addon p-inputrut-separator">
                <i className="bi bi-dash"></i>
            </span>
            <InputText
                className="p-inputrut-dv"
                style={{ width: '40px', flexGrow: 0 }}
                value={dvRut}
                maxLength={1}
                disabled={disabled}
                onChange={onDvRutChange}
                keyfilter={/^[0123456789kK]+$/}
            />
        </div>
    );
};

export default InputRut;
